function getInitialState () {
    return {
        statuses: [1, 4],
        workarea: null
    }
}

const state = getInitialState()

const mutations = {
    'FILTER_SET_STATUSES' (state, statuses) {
        state.statuses = statuses
    },
    'FILTER_SET_WORKAREA' (state, workarea) {
        state.workarea = workarea
    },
    'FILTER_RESET' (state) {
        state = Object.assign(state, getInitialState())
    }
}

const getters = {
    getFilters: (state) => {
        return {statuses: state.statuses, workarea: state.workarea}
    }
}

export default {
    state,
    mutations,
    getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/filter.js